import Firebase from 'app/src/components/Firebase';

export const firebase = new Firebase();
